import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const RecognizedSpecialityFilter = ({ label = "l.searchFilter.recognizedSpeciality", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"recognizedSpeciality"} label={label} {...others} />
    </>
  );
};

export default RecognizedSpecialityFilter;
